import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom"; 
import axios from "axios";
import { toast } from "react-hot-toast";
import LoginWallPaper from "../assest/login.jpeg";

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate(); 
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!newPassword || !confirmPassword) {
      toast.error("Both fields are required.");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }

   

    setIsSubmitting(true);

    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      const response = await axios.post(
        `${API_URL}/Users/resetPassword/${token}`,
        { newPassword }
      );

      if (response.data.success) {
        toast.success("Password has been reset successfully!");
        setNewPassword("");
        setConfirmPassword("");
        navigate("/");
      } else {
        toast.error(response.data.message || "Failed to reset password.");
      }
    } catch (err) {
      toast.error(
        err.response?.data?.message || "An error occurred. Please try again."
      );
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex h-screen">
      {/* Left Column */}
      <div className="w-1/2 flex items-center justify-center">
        <div className="scale-95">
          <img
            src={LoginWallPaper}
            alt="LoginWallPaper"
            className="h-screen rounded-3xl"
          />
        </div>
      </div>

      {/* Right Column */}
      <div className="w-1/2 flex items-center justify-center">
        <div>
          <div className="bg-white rounded-2xl px-8 py-8 w-full sm:w-96 mx-8 sm:mx-0 shadow-2xl">
            <form className="mt-6" onSubmit={handleSubmit}>
              <h1 className="text-[26px]">Password Reset</h1>

              <div className="relative mt-4">
                <label className="block" htmlFor="newPassword">
                  New Password
                </label>
                <input
                  type={showNewPassword ? "text" : "password"}
                  id="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Enter new password"
                  required
                  className="mt-1 block w-full bg-gray-100 px-4 py-3 rounded-xl"
                />
                <button
                  type="button"
                  className="absolute top-9 right-3 text-gray-500"
                  onClick={() => setShowNewPassword(!showNewPassword)}
                >
                  {showNewPassword ? "Hide" : "Show"}
                </button>
              </div>

              <div className="relative mt-4">
                <label className="block" htmlFor="confirmPassword">
                  Confirm New Password
                </label>
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  id="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm new password"
                  required
                  className="mt-1 block w-full bg-gray-100 px-4 py-3 rounded-xl"
                />
                <button
                  type="button"
                  className="absolute top-9 right-3 text-gray-500"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? "Hide" : "Show"}
                </button>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className={`block w-full mt-6 ${
                  isSubmitting
                    ? "bg-gray-400"
                    : "bg-[#6C0B67] text-white hover:scale-105 active:scale-95 hover:shadow-xl"
                } rounded-xl px-4 py-3 transition`}
              >
                {isSubmitting ? "Submitting..." : "Reset Password"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
